// extracted by mini-css-extract-plugin
export default {"overflowHidden":"xb1RmW6lS6lI2v7ittVY","suggestionsDropdown":"L7IFh3y0bCerfN6T4eGk"};